import { StateCreator } from 'zustand';
import { SortDirection } from '../types.ts';

export const scope = 'workflowExecutions';

export type FilterConfig = {
  operator: 'eq' | 'lte' | 'gte' | 'like' | 'ilike';
  value: string | null;
  attribute: string;
};

export const INITIAL_FILTERS: FilterConfig[] = [
  {
    operator: 'eq',
    value: null,
    attribute: 'parent_execution_id',
  },
];

type State = {
  executionsSelectedWorkflowId: string | null;
  executionsSortColumn: string;
  executionsSortDirection: SortDirection;
  executionsFilters: FilterConfig[];
};

type Actions = {
  setExecutionsSelectedWorkflowId: (workflowId: string | null) => void;
  setExecutionsSortColumn: (sortColumn: string) => void;
  setExecutionsSortDirection: (direction: SortDirection) => void;
  setExecutionsFilters: (filters: FilterConfig[] | null) => void;
};

export type WorkflowExecutionsSlice = State & Actions;

export const createWorkflowExecutionsSlice: StateCreator<
  WorkflowExecutionsSlice,
  [['zustand/immer', never]],
  [],
  WorkflowExecutionsSlice
> = (set) => ({
  executionsSelectedWorkflowId: null,
  executionsSortColumn: 'end_time',
  executionsSortDirection: '-',
  executionsFilters: INITIAL_FILTERS,
  setExecutionsSelectedWorkflowId: (executionsSelectedWorkflowId) => set(() => ({ executionsSelectedWorkflowId })),
  setExecutionsSortColumn: (executionsSortColumn) => set(() => ({ executionsSortColumn })),
  setExecutionsSortDirection: (executionsSortDirection) => set(() => ({ executionsSortDirection })),
  setExecutionsFilters: (executionsFilters) => set(() => ({ executionsFilters })),
});
